module.exports = __webpack_public_path__ + "img/IMG_5694.dd91f795.jpg";